export const GET_SELLER_ID_FROM_COOKIE = "GET_SELLER_ID_FROM_COOKIE";
export const PERSIST_USER_DATA_PENDING = "PERSIST_USER_DATA_PENDING";
export const PERSIST_USER_DATA_SUCCESS = "PERSIST_USER_DATA_SUCCESS";
export const PERSIST_USER_DATA_FAIL = "PERSIST_USER_DATA_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const LOGOUT_PENDING = "LOGOUT_PENDING";
export const SET_LOGIN_STATUS = "SET_LOGIN_STATUS";
